import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityOutputqueue } from "../../entity/EntityOutputqueue";

export class DtoOutputqueuesGetReq extends EntityOutputqueue {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_outputqueue_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
